import React from 'react';
import Info from '../../../../assets/images/icon_info.svg';
import injectStyles from 'react-jss';

const InfoIcon = ({ classes }) => <img src={Info} alt="info" className={classes.icon__info} />;

const styles = theme => ({
  icon__info: {
    backgroundColor: 'transparent',
    color: theme.colors.white,
    flexShrink: 0,
    height: '24px',
    width: '24px',
  },
});

export default injectStyles(styles)(InfoIcon);
